import { useState } from "react";

// ESPN shot coordinates: x 0–50 ft across the court, y in ft from the basket (basket ≈ 25,0).
export function ShotChart({ shots, game }) {
  const [side, setSide] = useState("both");
  if (!shots?.length) return <p className="tv-empty" data-testid="tv-no-shots">Shot locations not available</p>;
  const list = shots.filter((s) => side === "both" || s.team === side);
  const made = list.filter((s) => s.made).length;
  const depth = Math.max(32, ...shots.map((s) => s.y + 2));
  return (
    <div className="tv-shots" data-testid="tv-shotchart">
      <div className="tv-shot-filter">
        {[["both", "Both"], ["away", game.away_code], ["home", game.home_code]].map(([k, l]) => (
          <button key={k} type="button" className={side === k ? "is-active" : ""} onClick={() => setSide(k)}>{l}</button>
        ))}
        <span>{made}/{list.length} made</span>
      </div>
      <svg viewBox={`0 -4 50 ${depth + 4}`} className="tv-court" role="img" aria-label="Shot chart">
        <rect x="0" y="-4" width="50" height={depth + 4} className="tv-court-floor" />
        <rect x="17" y="-4" width="16" height="19" className="tv-court-line" />
        <circle cx="25" cy="15" r="6" className="tv-court-line" />
        <path d="M3 -4 V8.95 A23.75 23.75 0 0 0 47 8.95 V-4" className="tv-court-line" />
        <circle cx="25" cy="0" r="0.75" className="tv-court-line" />
        <line x1="22" y1="-1.25" x2="28" y2="-1.25" className="tv-court-line" />
        {list.map((s, i) => (
          <circle key={i} cx={s.x} cy={s.y} r="0.8" className={`tv-shot ${s.made ? "made" : "missed"} ${s.team}`} />
        ))}
      </svg>
      <div className="tv-legend"><span className="made" />Made<span className="missed" />Missed</div>
    </div>
  );
}

export function ScoreProgression({ points, game }) {
  if (!points || points.length < 2) return <p className="tv-empty">Score progression not available.</p>;
  const max = Math.max(...points.flatMap((p) => [p.away, p.home]), 1);
  const line = (k) => points.map((p, i) => `${(i * 400) / (points.length - 1)},${165 - (p[k] * 150) / max}`).join(" ");
  return (
    <div className="tv-progression" data-testid="tv-progression">
      <svg viewBox="0 0 400 170" preserveAspectRatio="none" role="img" aria-label="Score progression">
        <polyline fill="none" stroke="#24a2ff" strokeWidth="2.5" points={line("away")} />
        <polyline fill="none" stroke="#f2bd51" strokeWidth="2.5" points={line("home")} />
      </svg>
      <div className="tv-legend"><span style={{ background: "#24a2ff" }} />{game.away_code}<span style={{ background: "#f2bd51" }} />{game.home_code}</div>
    </div>
  );
}
